import React, { forwardRef } from 'react'
import PropTypes from 'prop-types'
import { clsx } from 'clsx'
import SvgCalendar from './svgCalendar'
import moment from 'moment'
// styles
import styles from './styles.dateRange.module.scss'

const InputDateRange = forwardRef((props, ref) => {
  const { value, onClick, className: classNameInput = '', isClearable, dateFormat } = props

  const dates = value.split(' - ').map((date) => date.trim()) // Eliminar espacios adicionales
  const formattedDates = dates.map((date) => moment(date, dateFormat).format(dateFormat))

  return (
    <button
      type="button"
      className={clsx(styles.InputDateRange, classNameInput)}
      onClick={onClick}
      ref={ref}
    >
      {!value ? (
        <>
          <span>{`${dateFormat}`}</span>
          <span>-</span>
          <span>{`${dateFormat}`}</span>
        </>
      ) : (
        <>
          {formattedDates[0] && formattedDates[0] !== 'Invalid date' && (
            <span>{`${formattedDates[0]}`}</span>
          )}
          {formattedDates[1] && formattedDates[1] !== 'Invalid date' && (
            <span>{`${formattedDates[1]}`}</span>
          )}
        </>
      )}

      <SvgCalendar className={clsx(isClearable && 'mr-[20px]')} />
    </button>
  )
})

InputDateRange.propTypes = {
  value: PropTypes.any,
  onClick: PropTypes.func,
  className: PropTypes.string,
  isClearable: PropTypes.bool,
  dateFormat: PropTypes.string,
}

export default InputDateRange
